export default function(type,text){
    return {type,text}
}